(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pnoe-box-home-campaign"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-pnoe-box-home-cta]');
    if (!link) return;
    try {
      window.Shopify?.analytics?.publish?.('pnoe_box_home_cta_click', {
        source: 'homepage_campaign',
        campaign: 'pnoe_box_42_2026_10'
      });
    } catch (_) {}
    try {
      window.dataLayer?.push?.({
        event: 'pnoe_box_home_cta_click',
        pnoe_source: 'homepage_campaign',
        pnoe_campaign: 'pnoe_box_42_2026_10'
      });
    } catch (_) {}
  }, {passive: true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pnoe-box"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-pnoe-box]').forEach((root)=>{
  if(root.dataset.pnoeReady==='true') return;
  root.dataset.pnoeReady='true';

  const config=JSON.parse(root.querySelector('[data-pnoe-box-config]').textContent);
  const selected={};
  const seen={1:new Set(),2:new Set(),3:new Set()};
  const loader={};
  const activeCollection={1:'all',2:'all',3:'all'};
  let builderStarted=false;
  const builderSource='pnoe_custom_builder_v1';
  const builderCampaign='pnoe_box_42_2026_10';
  const sourceParams=new URLSearchParams(window.location.search);
  const urlEntrySource=sourceParams.get('pnoe_source');
  if(urlEntrySource){
    try{sessionStorage.setItem('pnoe_builder_entry',urlEntrySource);}catch(_){}
  }
  let builderEntry='direct_builder';
  try{
    builderEntry=urlEntrySource||sessionStorage.getItem('pnoe_builder_entry')||'direct_builder';
  }catch(_){
    builderEntry=urlEntrySource||'direct_builder';
  }
  const publishBuilderEvent=(name,data={})=>{
    try{window.Shopify?.analytics?.publish?.(name,{source:builderSource,campaign:builderCampaign,...data});}catch(_){}
    try{window.dataLayer?.push?.({event:name,pnoe_source:builderSource,pnoe_campaign:builderCampaign,...data});}catch(_){}
  };

  [1,2,3].forEach((step)=>{
    loader[step]={
      collections:(config.collections[String(step)]||[]).map((collection)=>({...collection,page:1,done:false})),
      cursor:0,
      loading:false,
      initialized:false
    };
  });

  const panel=(step)=>root.querySelector('[data-step-panel="'+step+'"]');
  const grid=(step)=>panel(step)?.querySelector('[data-products-grid]');
  const relevantCollections=(step)=>loader[step].collections.filter((collection)=>activeCollection[step]==='all'||collection.handle===activeCollection[step]);
  const hasMore=(step)=>relevantCollections(step).some((collection)=>!collection.done);

  const updateLoadedCount=(step,override)=>{
    const node=panel(step)?.querySelector('[data-loaded-count]');
    if(!node) return;
    if(override){node.textContent=override;return;}
    const count=grid(step)?.querySelectorAll('[data-product-card]:not([hidden])').length||0;
    node.textContent=config.loadedLabel.replace('__count__',String(count));
  };

  const filterCards=(step)=>{
    const input=panel(step)?.querySelector('[data-product-search]');
    const term=(input?.value||'').trim().toLocaleLowerCase();
    let visible=0;
    grid(step)?.querySelectorAll('[data-product-card]').forEach((card)=>{
      const title=(card.dataset.title||'').toLocaleLowerCase();
      const collections=(card.dataset.collections||'').split(' ').filter(Boolean);
      const collectionMatch=activeCollection[step]==='all'||collections.includes(activeCollection[step]);
      const match=collectionMatch&&(!term||title.includes(term));
      card.hidden=!match;
      if(match) visible+=1;
    });
    const empty=panel(step)?.querySelector('[data-no-results]');
    if(empty) empty.hidden=visible>0||hasMore(step);
    updateLoadedCount(step);
    return visible;
  };

  const refresh=()=>{
    let completed=0;
    [1,2,3].forEach((step)=>{
      const summary=root.querySelector('[data-summary="'+step+'"]');
      const row=root.querySelector('[data-summary-row="'+step+'"]');
      const nav=root.querySelector('[data-step-nav="'+step+'"]');
      if(selected[step]){
        completed+=1;
        if(summary) summary.textContent=selected[step].title;
        row?.classList.add('is-complete');
        nav?.classList.add('is-complete');
      }else{
        row?.classList.remove('is-complete');
        nav?.classList.remove('is-complete');
      }
      const next=panel(step)?.querySelector('[data-next-step]');
      if(next) next.disabled=!selected[step];
    });
    const add=root.querySelector('[data-add-box]');
    if(add) add.disabled=completed!==3;
    const progress=root.querySelector('[data-progress-text]');
    if(progress) progress.textContent=completed+'/3';
    const bar=root.querySelector('[data-progress-bar]');
    if(bar) bar.style.width=(completed/3*100)+'%';
  };

  const go=(step)=>{
    if(step<1||step>3) return;
    root.querySelectorAll('[data-step-panel]').forEach((item)=>item.classList.toggle('is-active',Number(item.dataset.stepPanel)===step));
    root.querySelectorAll('[data-step-nav]').forEach((item)=>item.classList.toggle('is-active',Number(item.dataset.stepNav)===step));
    ensureLoaded(step);
    const target=panel(step);
    if(target){
      const offset=90;
      const top=target.getBoundingClientRect().top+window.scrollY-offset;
      window.scrollTo({top,behavior:'smooth'});
    }
  };

  const hydrateCards=(step,source)=>{
    const target=grid(step);
    if(!target) return 0;
    let added=0;
    source.querySelectorAll('[data-product-card]').forEach((card)=>{
      if(config.hideSoldOut&&card.dataset.available!=='true') return;
      const productId=card.dataset.productId;
      const incomingCollections=(card.dataset.collections||source.dataset.collection||'').split(' ').filter(Boolean);
      if(seen[step].has(productId)){
        const existing=target.querySelector('[data-product-id="'+productId+'"]');
        if(existing){
          const merged=new Set([...(existing.dataset.collections||'').split(' ').filter(Boolean),...incomingCollections]);
          existing.dataset.collections=[...merged].join(' ');
        }
        return;
      }
      seen[step].add(productId);
      card.dataset.step=String(step);
      card.dataset.collections=[...new Set(incomingCollections)].join(' ');
      target.appendChild(card);
      added+=1;
    });
    filterCards(step);
    return added;
  };

  const loadNextBatch=async(step)=>{
    const state=loader[step];
    if(!state||state.loading) return;
    const open=relevantCollections(step).filter((collection)=>!collection.done);
    if(!open.length){
      panel(step)?.querySelector('[data-load-more]')?.setAttribute('hidden','');
      filterCards(step);
      return;
    }

    const collection=open[state.cursor%open.length];
    state.cursor+=1;
    state.loading=true;
    const loading=panel(step)?.querySelector('[data-products-loading]');
    if(loading) loading.hidden=false;
    const more=panel(step)?.querySelector('[data-load-more]');
    if(more) more.hidden=true;

    try{
      const url=new URL(collection.url,window.location.origin);
      url.searchParams.set('view',config.view);
      url.searchParams.set('page',String(collection.page));
      const response=await fetch(url.toString(),{headers:{'X-Requested-With':'XMLHttpRequest'}});
      if(!response.ok) throw new Error('products');
      const html=await response.text();
      const doc=new DOMParser().parseFromString(html,'text/html');
      const source=doc.querySelector('[data-pnoe-items-page]');
      if(!source) throw new Error('markup');
      hydrateCards(step,source);
      collection.done=source.dataset.hasNext!=='true';
      collection.page+=1;
    }catch(error){
      if(more) more.hidden=false;
    }finally{
      state.loading=false;
      if(loading) loading.hidden=true;
      if(more) more.hidden=!hasMore(step);
      filterCards(step);
    }
  };

  const ensureLoaded=async(step)=>{
    if(loader[step].initialized) return;
    loader[step].initialized=true;
    await loadNextBatch(step);
  };

  const deepSearch=async(step)=>{
    const input=panel(step)?.querySelector('[data-product-search]');
    const term=(input?.value||'').trim().toLocaleLowerCase();
    if(term.length<2) return;
    let visible=filterCards(step);
    while(visible<24&&hasMore(step)&&input&&input.value.trim().toLocaleLowerCase()===term){
      updateLoadedCount(step,config.searchingLabel);
      await loadNextBatch(step);
      visible=filterCards(step);
    }
  };

  const fillVisible=async(step,minVisible=18)=>{
    let visible=filterCards(step);
    let passes=0;
    while(visible<minVisible&&hasMore(step)&&passes<4){
      await loadNextBatch(step);
      visible=filterCards(step);
      passes+=1;
    }
  };

  root.addEventListener('click',(event)=>{
    const filterButton=event.target.closest('[data-collection-filter]');
    if(filterButton&&root.contains(filterButton)){
      const currentPanel=filterButton.closest('[data-step-panel]');
      const step=Number(currentPanel.dataset.stepPanel);
      activeCollection[step]=filterButton.dataset.collectionFilter||'all';
      currentPanel.querySelectorAll('[data-collection-filter]').forEach((button)=>{
        const active=button===filterButton;
        button.classList.toggle('is-active',active);
        button.setAttribute('aria-pressed',active?'true':'false');
      });
      fillVisible(step);
      return;
    }

    const select=event.target.closest('[data-select-product]');
    if(select&&root.contains(select)){
      const card=select.closest('[data-product-card]');
      const step=Number(card.dataset.step);
      grid(step)?.querySelectorAll('[data-product-card]').forEach((item)=>item.classList.remove('is-selected'));
      card.classList.add('is-selected');
      const variant=card.querySelector('[data-variant-select]');
      selected[step]={
        variantId:Number(variant.value),
        title:card.dataset.title||card.querySelector('.pnoe-box__name')?.textContent.trim()||'',
        card
      };
      if(!builderStarted){
        builderStarted=true;
        publishBuilderEvent('pnoe_box_builder_started',{step});
      }
      refresh();
      if(config.autoAdvance&&card.dataset.singleVariant==='true'&&step<3){
        window.setTimeout(()=>go(step+1),260);
      }
      return;
    }

    const next=event.target.closest('[data-next-step]');
    if(next){go(Number(next.closest('[data-step-panel]').dataset.stepPanel)+1);return;}
    const prev=event.target.closest('[data-prev-step]');
    if(prev){go(Number(prev.closest('[data-step-panel]').dataset.stepPanel)-1);return;}
    const nav=event.target.closest('[data-step-nav]');
    if(nav){go(Number(nav.dataset.stepNav));return;}
    const more=event.target.closest('[data-load-more]');
    if(more){loadNextBatch(Number(more.closest('[data-step-panel]').dataset.stepPanel));return;}
  });

  root.addEventListener('change',(event)=>{
    const variant=event.target.closest('[data-variant-select]');
    if(!variant) return;
    const card=variant.closest('[data-product-card]');
    const step=Number(card.dataset.step);
    if(selected[step]?.card===card){
      selected[step].variantId=Number(variant.value);
      if(config.autoAdvance&&step<3) window.setTimeout(()=>go(step+1),220);
    }
  });

  root.querySelectorAll('[data-product-search]').forEach((input)=>{
    let timer;
    input.addEventListener('input',()=>{
      const step=Number(input.closest('[data-step-panel]').dataset.stepPanel);
      filterCards(step);
      window.clearTimeout(timer);
      timer=window.setTimeout(()=>deepSearch(step),320);
    });
  });

  const observer=new IntersectionObserver((entries)=>{
    entries.forEach((entry)=>{
      if(!entry.isIntersecting) return;
      const step=Number(entry.target.closest('[data-step-panel]').dataset.stepPanel);
      loadNextBatch(step);
    });
  },{rootMargin:'500px 0px'});
  root.querySelectorAll('[data-load-sentinel]').forEach((sentinel)=>observer.observe(sentinel));

  root.querySelector('[data-add-box]')?.addEventListener('click',async()=>{
    const button=root.querySelector('[data-add-box]');
    const status=root.querySelector('[data-status]');
    if(![1,2,3].every((step)=>selected[step])) return;
    button.disabled=true;
    status.textContent='';

    const token='pnoe-'+Date.now().toString(36)+'-'+Math.random().toString(36).slice(2,8);
    const items=[
      ...[1,2,3].map((step)=>({
        id:selected[step].variantId,
        quantity:1,
        properties:{
          _pnoe_box_component:'1',
          _pnoe_box_token:token,
          _pnoe_box_step:String(step),
          _pnoe_builder_source:builderSource,
          _pnoe_builder_campaign:builderCampaign,
          _pnoe_builder_entry:builderEntry
        }
      })),
      {
        id:Number(config.boxVariantId),
        quantity:1,
        properties:{
          _pnoe_box_parent:'1',
          _pnoe_box_token:token,
          _pnoe_builder_source:builderSource,
          _pnoe_builder_campaign:builderCampaign,
          _pnoe_builder_entry:builderEntry,
          _pnoe_box_watch:selected[1].title,
          _pnoe_box_necklace:selected[2].title,
          _pnoe_box_third:selected[3].title
        }
      }
    ];

    try{
      const response=await fetch(config.cartAddUrl+'.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items})
      });
      if(!response.ok) throw new Error('cart');

      if(config.cartUpdateUrl){
        try{
          await fetch(config.cartUpdateUrl+'.js',{
            method:'POST',
            headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({
              discount:'',
              attributes:{
                pnoe_builder_source__:builderSource,
                pnoe_builder_campaign__:builderCampaign,
                pnoe_builder_entry__:builderEntry,
                pnoe_builder_token__:token
              }
            })
          });
        }catch(_){}
      }

      publishBuilderEvent('pnoe_box_builder_added_to_cart',{
        token,
        box_price:config.boxPrice,
        watch:selected[1].title,
        necklace:selected[2].title,
        third:selected[3].title
      });
      status.textContent=config.successMessage;
      window.location.href=config.cartUrl;
    }catch(error){
      status.textContent=config.errorMessage;
      button.disabled=false;
    }
  });

  refresh();
  ensureLoaded(1).then(()=>{
    const warm=()=>ensureLoaded(2);
    if('requestIdleCallback' in window){
      window.requestIdleCallback(warm,{timeout:1600});
    }else{
      window.setTimeout(warm,900);
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pnoe-mobile-app"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('pnoe-mobile-app')) return;
  class PnoeMobileApp extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.media = matchMedia('(max-width: 767px)');
      this.dialog = this.querySelector('[data-pnoe-menu]');
      this.nav = this.querySelector('[data-pnoe-bottom-nav]');
      this.buy = this.querySelector('[data-pnoe-buy]');
      this.cartCount = this.querySelector('[data-pnoe-cart-count]');
      this.fourth = this.querySelector('[data-pnoe-fourth]');
      this.wishlistDialog = this.querySelector('[data-pnoe-wishlist-dialog]');
      this.wishlistList = this.querySelector('[data-pnoe-wishlist-list]');
      this.wishlistEmpty = this.querySelector('[data-pnoe-wishlist-empty]');
      this.wishlistCount = this.querySelector('[data-pnoe-wishlist-count]');
      this.wishlistStorageKey = 'pnoeWishlistV1';
      this.wishlistObserver = null;
      this.wishlistSyncFrame = null;
      this.lastRawCount = null;
      this.lastFetch = 0;
      this.maxViewport = window.visualViewport?.height || window.innerHeight;
      this.floaterFrame = null;
      this.floaterObserver = null;
      this.shiftedFloaters = new Set();
      this.floaterOriginalPosition = new Map();
      const signal = this.controller.signal;
      this.addEventListener('click', (event) => this.onClick(event), { signal });
      document.addEventListener('click', (event) => this.onWishlistDocumentClick(event), { signal });
      this.dialog?.addEventListener('close', () => {
        document.documentElement.classList.remove('pnoe-mobile-menu-open');
        this.querySelector('[data-pnoe-action="menu"]')?.setAttribute('aria-expanded', 'false');
      }, { signal });
      this.media.addEventListener('change', () => this.syncViewport(), { signal });
      document.addEventListener('focusin', () => this.queueFrame(), { signal });
      document.addEventListener('focusout', () => this.queueFrame(), { signal });
      window.visualViewport?.addEventListener('resize', () => this.queueFrame(), { signal });
      window.addEventListener('scroll', () => this.queueFrame(), { passive: true, signal });
      window.addEventListener('resize', () => { this.queueFrame(); this.queueFloaterLayout(); }, { passive: true, signal });
      window.addEventListener('pageshow', (event) => {
        this.syncViewport();
        if (event.persisted && this.media.matches) this.queueCartRefresh();
      }, { signal });
      document.addEventListener('cart:updated', (event) => {
        if (!this.media.matches) return;
        if (Array.isArray(event.detail?.cart?.items)) this.setCart(event.detail.cart);
        else this.queueCartRefresh();
      }, { signal });
      this.syncViewport();
      this.startWishlistObserver();
      this.syncWishlistUI();
      window.setTimeout(() => this.queueFloaterLayout(), 120);
      window.setTimeout(() => this.queueFloaterLayout(), 700);
      window.setTimeout(() => this.queueFloaterLayout(), 1800);
    }
    disconnectedCallback() {
      this.stopMobile();
      this.controller?.abort();
      this.controller = null;
      clearTimeout(this.refreshTimer);
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.floaterFrame);
      this.floaterObserver?.disconnect();
      this.wishlistObserver?.disconnect();
      this.wishlistObserver=null;
      cancelAnimationFrame(this.wishlistSyncFrame);
      this.wishlistSyncFrame=null;
      this.restoreExternalFloaters();
    }
    syncViewport() {
      if (!this.media.matches) { this.stopMobile(); return; }
      document.documentElement.classList.add('pnoe-mobile-active');
      document.documentElement.classList.toggle('pnoe-mobile-polish', this.dataset.polish === 'true');
      if (this.mobileStarted) { this.queueFrame(); this.queueFloaterLayout(); return; }
      this.mobileStarted = true;
      this.header = document.querySelector('header-component');
      const template = this.querySelector('[data-pnoe-discovery-template]');
      const main = document.getElementById('MainContent');
      if (template && main) {
        this.discovery = template.content.firstElementChild.cloneNode(true);
        main.prepend(this.discovery);
        this.discovery.addEventListener('click', (event) => this.onClick(event), { signal: this.controller.signal });
      }
      const backTemplate = this.querySelector('[data-pnoe-back-template]');
      const left = this.header?.querySelector('.header__left');
      if (backTemplate && left) {
        this.back = backTemplate.content.firstElementChild.cloneNode(true);
        left.prepend(this.back);
        this.back.addEventListener('click', () => {
          let internal = false;
          try { internal = new URL(document.referrer).origin === location.origin; } catch (_) {}
          if (internal && history.length > 1) history.back();
          else location.assign(this.dataset.homeUrl);
        }, { signal: this.controller.signal });
      }
      if (this.header) {
        const inspect = () => {
          this.resolveFourthTab();
          const raw = this.header.querySelector('[data-cart-badge]')?.textContent.trim();
          if (raw != null && this.lastRawCount != null && raw !== this.lastRawCount) this.queueCartRefresh();
          this.lastRawCount = raw ?? this.lastRawCount;
        };
        inspect();
        this.headerObserver = new MutationObserver(inspect);
        this.headerObserver.observe(this.header, { childList: true, characterData: true, subtree: true });
      }
      this.resolveFourthTab();
      this.queueFrame();
      this.startFloaterObserver();
      this.queueFloaterLayout();
    }

    startFloaterObserver() {
      if (this.floaterObserver || !document.body) return;
      this.floaterObserver = new MutationObserver(() => this.queueFloaterLayout());
      this.floaterObserver.observe(document.body, { childList: true, subtree: true });
    }

    queueFloaterLayout() {
      if (!this.media?.matches || this.floaterFrame) return;
      this.floaterFrame = requestAnimationFrame(() => {
        this.floaterFrame = null;
        this.layoutExternalFloaters();
      });
    }

    layoutExternalFloaters() {
      if (!this.nav || !this.media.matches) return;
      const navRect = this.nav.getBoundingClientRect();
      const viewportHeight = window.visualViewport?.height || window.innerHeight;
      const safeTop = Math.max(0, navRect.top - 10);
      const selectors = [
        'iframe',
        '[style*="position: fixed"]',
        '[style*="position:fixed"]',
        '[class*="loyal" i]',
        '[id*="loyal" i]',
        '[class*="reward" i]',
        '[id*="reward" i]',
        '[class*="point" i]',
        '[id*="point" i]',
        '[class*="honeypop" i]',
        '[id*="honeypop" i]',
        '[class*="essential" i]',
        '[id*="essential" i]'
      ].join(',');

      const candidates = new Set(document.querySelectorAll(selectors));
      document.body?.querySelectorAll(':scope > *').forEach((node) => candidates.add(node));

      candidates.forEach((el) => {
        if (!(el instanceof HTMLElement)) return;
        if (el.closest('pnoe-mobile-app, #Cart-Drawer, header-component, [data-newsletter-popup], [data-newsletter-popup-float], dialog, .modal')) return;

        const style = getComputedStyle(el);
        if (style.position !== 'fixed') return;

        const rect = el.getBoundingClientRect();
        if (!rect.width || !rect.height || rect.width > 300 || rect.height > 180) return;

        const descriptor = [
          el.id,
          el.className,
          el.getAttribute('aria-label'),
          el.getAttribute('title'),
          el.getAttribute('src'),
          el.textContent
        ].filter(Boolean).join(' ').toLocaleLowerCase();

        const isLoyaltyLauncher =
          /loyal|reward|point|πόντ|honeypop|essential/.test(descriptor);

        if (isLoyaltyLauncher && document.body.classList.contains('page-cart')) {
          if (!this.floaterOriginalPosition.has(el)) {
            this.floaterOriginalPosition.set(el, {
              left: el.style.getPropertyValue('left'),
              leftPriority: el.style.getPropertyPriority('left'),
              right: el.style.getPropertyValue('right'),
              rightPriority: el.style.getPropertyPriority('right'),
              top: el.style.getPropertyValue('top'),
              topPriority: el.style.getPropertyPriority('top'),
              bottom: el.style.getPropertyValue('bottom'),
              bottomPriority: el.style.getPropertyPriority('bottom'),
              visibility: el.style.getPropertyValue('visibility'),
              visibilityPriority: el.style.getPropertyPriority('visibility'),
              pointerEvents: el.style.getPropertyValue('pointer-events'),
              pointerEventsPriority: el.style.getPropertyPriority('pointer-events')
            });
          }
          el.style.setProperty('visibility', 'hidden', 'important');
          el.style.setProperty('pointer-events', 'none', 'important');
          this.shiftedFloaters.add(el);
          return;
        }

        if (isLoyaltyLauncher) {
          if (!this.floaterOriginalPosition.has(el)) {
            this.floaterOriginalPosition.set(el, {
              left: el.style.getPropertyValue('left'),
              leftPriority: el.style.getPropertyPriority('left'),
              right: el.style.getPropertyValue('right'),
              rightPriority: el.style.getPropertyPriority('right'),
              top: el.style.getPropertyValue('top'),
              topPriority: el.style.getPropertyPriority('top'),
              bottom: el.style.getPropertyValue('bottom'),
              bottomPriority: el.style.getPropertyPriority('bottom')
            });
          }

          const loyaltyBottom = Math.ceil(Math.max(18, viewportHeight - navRect.top + 18));
          el.style.setProperty('top', 'auto', 'important');
          el.style.setProperty('bottom', loyaltyBottom + 'px', 'important');
          el.style.removeProperty('translate');
          delete el.dataset.pnoeFloaterShift;
          delete el.dataset.pnoeFloaterShifted;

          if (rect.width > 72) {
            el.style.setProperty('left', 'auto', 'important');
            el.style.setProperty('right', '12px', 'important');
            el.dataset.pnoeLoyaltyRight = 'true';
          }

          this.shiftedFloaters.add(el);
          return;
        }

        const previousShift = Number(el.dataset.pnoeFloaterShift || 0);
        const originalTop = rect.top + previousShift;
        const originalBottom = rect.bottom + previousShift;
        if (originalTop < viewportHeight * 0.45) return;

        if (originalBottom <= safeTop) {
          if (el.dataset.pnoeFloaterShifted === 'true') {
            el.style.removeProperty('translate');
            delete el.dataset.pnoeFloaterShifted;
            delete el.dataset.pnoeFloaterShift;
            this.shiftedFloaters.delete(el);
          }
          return;
        }

        const shift = Math.ceil(originalBottom - safeTop + 8);
        if (shift !== previousShift) {
          el.style.setProperty('translate', '0 -' + shift + 'px', 'important');
          el.dataset.pnoeFloaterShift = String(shift);
        }
        el.dataset.pnoeFloaterShifted = 'true';
        this.shiftedFloaters.add(el);
      });
    }

    restoreExternalFloaters() {
      this.shiftedFloaters?.forEach((el) => {
        if (!el?.isConnected) return;
        el.style.removeProperty('translate');
        delete el.dataset.pnoeFloaterShifted;
        delete el.dataset.pnoeFloaterShift;
      });
      this.shiftedFloaters?.clear();

      this.floaterOriginalPosition?.forEach((position, el) => {
        if (!el?.isConnected) return;
        if (position.left) el.style.setProperty('left', position.left, position.leftPriority || '');
        else el.style.removeProperty('left');
        if (position.right) el.style.setProperty('right', position.right, position.rightPriority || '');
        else el.style.removeProperty('right');
        if (position.top) el.style.setProperty('top', position.top, position.topPriority || '');
        else el.style.removeProperty('top');
        if (position.bottom) el.style.setProperty('bottom', position.bottom, position.bottomPriority || '');
        else el.style.removeProperty('bottom');
        if (position.visibility) el.style.setProperty('visibility', position.visibility, position.visibilityPriority || '');
        else el.style.removeProperty('visibility');
        if (position.pointerEvents) el.style.setProperty('pointer-events', position.pointerEvents, position.pointerEventsPriority || '');
        else el.style.removeProperty('pointer-events');
        delete el.dataset.pnoeLoyaltyRight;
      });
      this.floaterOriginalPosition?.clear();
    }

    stopMobile() {
      if (this.dialog?.open) this.dialog.close();
      this.headerObserver?.disconnect();
      this.floaterObserver?.disconnect();
      this.floaterObserver = null;
      this.restoreExternalFloaters();
      this.discovery?.remove();
      this.back?.remove();
      this.discovery = null;
      this.back = null;
      this.mobileStarted = false;
      this.buy?.setAttribute('hidden', '');
      this.removeAttribute('data-keyboard-open');
      document.documentElement.classList.remove('pnoe-mobile-active', 'pnoe-mobile-polish', 'pnoe-mobile-menu-open');
      clearTimeout(this.refreshTimer);
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.floaterFrame);
      this.frame = null;
      this.floaterFrame = null;
    }
    resolveFourthTab() {
      if (!this.fourth) return;
      this.fourth.dataset.pnoeAction = 'wishlist';
      this.fourth.dataset.wishlist = 'true';
      this.fourth.removeAttribute('href');
      this.fourth.removeAttribute('aria-current');
      this.syncWishlistUI();
    }

    startWishlistObserver() {
      if (this.wishlistObserver || !document.getElementById('MainContent')) return;
      this.wishlistObserver = new MutationObserver(() => {
        if (this.wishlistSyncFrame) return;
        this.wishlistSyncFrame = requestAnimationFrame(() => {
          this.wishlistSyncFrame = null;
          this.syncWishlistUI();
        });
      });
      this.wishlistObserver.observe(document.getElementById('MainContent'), {childList:true,subtree:true});
    }

    cleanWishlistPrice(value) {
      let text=String(value||'').trim();
      if(!text) return '';
      try{
        const textarea=document.createElement('textarea');
        textarea.innerHTML=text;
        text=textarea.value;
      }catch(_){}
      try{
        const holder=document.createElement('div');
        holder.innerHTML=text;
        text=holder.textContent||holder.innerText||text;
      }catch(_){}
      return String(text).replace(/\s+/g,' ').trim();
    }

    readWishlist() {
      try {
        const parsed = JSON.parse(localStorage.getItem(this.wishlistStorageKey) || '[]');
        if(!Array.isArray(parsed)) return [];
        return parsed
          .filter((item)=>item&&item.id&&item.url)
          .map((item)=>({...item,price:this.cleanWishlistPrice(item.price)}));
      } catch (_) {
        return [];
      }
    }

    writeWishlist(items) {
      const normalized=items.slice(0,100).map((item)=>({...item,price:this.cleanWishlistPrice(item.price)}));
      try { localStorage.setItem(this.wishlistStorageKey, JSON.stringify(normalized)); } catch (_) {}
      this.syncWishlistUI(normalized);
    }

    productFromWishlistButton(button) {
      return {
        id: String(button.dataset.wishlistProductId || ''),
        handle: button.dataset.wishlistHandle || '',
        url: button.dataset.wishlistUrl || '',
        title: button.dataset.wishlistTitle || '',
        image: button.dataset.wishlistImage || '',
        price: this.cleanWishlistPrice(button.dataset.wishlistPrice || '')
      };
    }

    toggleWishlist(button) {
      const product = this.productFromWishlistButton(button);
      if (!product.id || !product.url) return;
      const items = this.readWishlist();
      const index = items.findIndex((item) => String(item.id) === product.id);
      if (index >= 0) items.splice(index, 1);
      else items.unshift(product);
      this.writeWishlist(items);
    }

    syncWishlistUI(items = this.readWishlist()) {
      const ids = new Set(items.map((item) => String(item.id)));
      document.querySelectorAll('[data-pnoe-wishlist-toggle]').forEach((button) => {
        const active = ids.has(String(button.dataset.wishlistProductId || ''));
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
        button.setAttribute('aria-label', active ? 'Αφαίρεση από τα αγαπημένα' : 'Προσθήκη στα αγαπημένα');
      });
      if (this.wishlistCount) {
        this.wishlistCount.textContent = items.length > 99 ? '99+' : String(items.length);
        this.wishlistCount.hidden = items.length === 0;
      }
      this.renderWishlist(items);
    }

    renderWishlist(items = this.readWishlist()) {
      if (!this.wishlistList || !this.wishlistEmpty) return;
      this.wishlistList.replaceChildren();
      this.wishlistEmpty.hidden = items.length > 0;
      this.wishlistList.hidden = items.length === 0;

      items.forEach((item) => {
        const row = document.createElement('article');
        row.className = 'pnoe-wishlist__item';

        const imageLink = document.createElement('a');
        imageLink.className = 'pnoe-wishlist__image';
        imageLink.href = item.url;
        if (item.image) {
          const image = document.createElement('img');
          image.src = item.image;
          image.alt = item.title || '';
          image.loading = 'lazy';
          imageLink.appendChild(image);
        }

        const info = document.createElement('div');
        info.className = 'pnoe-wishlist__info';
        const title = document.createElement('a');
        title.className = 'pnoe-wishlist__title';
        title.href = item.url;
        title.textContent = item.title || 'PNOE';
        info.appendChild(title);
        const cleanPrice=this.cleanWishlistPrice(item.price);
        if (cleanPrice) {
          const price = document.createElement('span');
          price.className = 'pnoe-wishlist__price';
          price.textContent = cleanPrice;
          info.appendChild(price);
        }

        const actions = document.createElement('div');
        actions.className = 'pnoe-wishlist__actions';
        const view = document.createElement('a');
        view.className = 'pnoe-wishlist__view';
        view.href = item.url;
        view.textContent = this.dataset.viewProductLabel || 'Προβολή';
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'pnoe-wishlist__remove';
        remove.dataset.pnoeWishlistRemove = String(item.id);
        remove.textContent = this.dataset.removeFavoriteLabel || 'Αφαίρεση';
        actions.append(view, remove);

        row.append(imageLink, info, actions);
        this.wishlistList.appendChild(row);
      });
    }

    openWishlist() {
      this.syncWishlistUI();
      if (typeof this.wishlistDialog?.showModal === 'function' && !this.wishlistDialog.open) this.wishlistDialog.showModal();
    }

    onWishlistDocumentClick(event) {
      const toggle = event.target.closest('[data-pnoe-wishlist-toggle]');
      if (toggle) {
        event.preventDefault();
        event.stopPropagation();
        this.toggleWishlist(toggle);
        return;
      }
      const remove = event.target.closest('[data-pnoe-wishlist-remove]');
      if (remove) {
        event.preventDefault();
        const id = String(remove.dataset.pnoeWishlistRemove || '');
        this.writeWishlist(this.readWishlist().filter((item) => String(item.id) !== id));
      }
    }

    onClick(event) {
      if (!this.media.matches || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (event.target === this.dialog) { this.dialog.close(); return; }
      const promo = event.target.closest('[data-pnoe-box-promo]');
      if (promo) {
        try { window.Shopify?.analytics?.publish?.('pnoe_box_promo_click', { source: 'pnoe_mobile_app' }); } catch (_) {}
      }
      const target = event.target.closest('[data-pnoe-action]');
      if (!target) return;
      switch (target.dataset.pnoeAction) {
        case 'menu':
          if (typeof this.dialog?.showModal !== 'function') return;
          event.preventDefault();
          if (!this.dialog.open) this.dialog.showModal();
          document.documentElement.classList.add('pnoe-mobile-menu-open');
          target.setAttribute('aria-expanded', 'true');
          break;
        case 'close':
          event.preventDefault(); this.dialog?.close(); break;
        case 'wishlist-close':
          event.preventDefault(); this.wishlistDialog?.close(); break;
        case 'search':
          // Keep native Shopify search links functional on mobile.
          // The header's overlay can report "open" but render behind
          // the header; never prevent the native /search navigation.
          break;
        case 'cart': {
          const drawer = document.getElementById('Cart-Drawer');
          if (typeof drawer?.show !== 'function') return;
          event.preventDefault();
          if (this.dialog?.open) this.dialog.close();
          drawer.show(target);
          this.queueCartRefresh();
          break;
        }
        case 'wishlist':
          event.preventDefault();
          this.openWishlist();
          break;
        case 'buy': {
          const info = document.querySelector('.section-main-product .main-product__details-column');
          if (!info) return;
          event.preventDefault();
          info.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          info.focus({ preventScroll: true });
          break;
        }
      }
    }
    queueFrame() {
      if (this.frame || !this.media.matches) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        const viewport = window.visualViewport;
        const height = viewport?.height || innerHeight;
        this.maxViewport = Math.max(this.maxViewport, height);
        const editing = document.activeElement?.matches('textarea, select, input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]), [contenteditable="true"]');
        this.dataset.keyboardOpen = String(Boolean(editing && this.maxViewport - height > 120 && (!viewport || viewport.scale < 1.1)));
        if (this.buy) {
          const action = document.querySelector('.section-main-product .product-action-zone');
          const rect = action?.getBoundingClientRect();
          const usableBottom = height - (this.nav?.getBoundingClientRect().height || 72) - 70;
          const visible = rect && rect.bottom > 0 && rect.top < usableBottom;
          this.buy.hidden = !rect || visible || scrollY < 120;
        }
      });
    }
    queueCartRefresh() {
      if (!this.media.matches) return;
      clearTimeout(this.refreshTimer);
      this.refreshTimer = setTimeout(() => this.refreshCart(), 180);
    }
    async refreshCart() {
      if (this.fetching || !this.media.matches) { this.needsRefresh = Boolean(this.fetching); return; }
      if (Date.now() - this.lastFetch < 300) { this.queueCartRefresh(); return; }
      this.fetching = true;
      this.lastFetch = Date.now();
      try {
        const response = await fetch(this.dataset.cartJsonUrl, { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store', signal: this.controller.signal });
        if (response.ok) this.setCart(await response.json());
      } catch (_) {} finally {
        this.fetching = false;
        if (this.needsRefresh) { this.needsRefresh = false; this.queueCartRefresh(); }
      }
    }
    setCart(cart) {
      if (!this.cartCount || !Array.isArray(cart.items)) return;
      const count = cart.items.reduce((total, item) => {
        const hidden = String(item.properties?._pnoe_box_component) === '1' ||
          Number(item.variant_id) === 58162810945885 ||
          String(item.properties?._pnoe_gift_wrap) === '1';
        return total + (hidden ? 0 : Number(item.quantity) || 0);
      }, 0);
      const value = count > 99 ? '99+' : String(count);
      if (this.cartCount.textContent.trim() !== value) this.cartCount.textContent = value;
      this.cartCount.hidden = count === 0;
    }
  }
  customElements.define('pnoe-mobile-app', PnoeMobileApp);
})();


  } catch(e) { console.error(e); }
})();
})();
